var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.301,
    height: 17.291,
    viewBox: "0 0 17.301 17.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(-5.999 -6.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LINE_57_",
    transform: "translate(13.982 12.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13196",
    "data-name": "Group 13196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38079",
    "data-name": "Path 38079",
    d: "M30.656,31.7a.666.666,0,0,1-.666-.666V25.775a.666.666,0,0,1,1.331,0V31.03A.665.665,0,0,1,30.656,31.7Z",
    transform: "translate(-29.99 -25.109)",
    fill: "#858585"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "POINT_1_",
    transform: "translate(13.982 10.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13197",
    "data-name": "Group 13197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38080",
    "data-name": "Path 38080",
    d: "M30.656,20.459a.664.664,0,0,1-.469-1.135.685.685,0,0,1,.938,0,.668.668,0,0,1,.2.473.67.67,0,0,1-.666.666Z",
    transform: "translate(-29.99 -19.136)",
    fill: "#858585"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_3_",
    transform: "translate(5.999 6.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13198",
    "data-name": "Group 13198",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38081",
    "data-name": "Path 38081",
    d: "M14.625,23.327a8.582,8.582,0,0,1-2.23-.293,8.7,8.7,0,1,1,2.23.293Zm.042-15.959a7.316,7.316,0,0,0-1.926,14.381A7.263,7.263,0,0,0,14.625,22h0A7.32,7.32,0,0,0,17.919,8.127a7.3,7.3,0,0,0-3.251-.76Z",
    transform: "translate(-5.999 -6.036)",
    fill: "#858585"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.dce53325.svg";
export { ForwardRef as ReactComponent };